import { Capacitor } from '@capacitor/core';
import { useQuasar } from 'quasar';

export const useMobile = () => {
  const $q = useQuasar();
  const isMobile = $q.screen.width < 600 || Capacitor.isNativePlatform();

  return {
    isMobile,
    dialogPosition: isMobile ? 'bottom' : 'standard',
  };
};
